import React, {Component} from "react";
import { Button } from "reactstrap";
import emptyStage from "../../../assets/empty-state_Illustration.svg";
import './NoData.css';

class NoData extends Component {

  goBack = () => {
    console.log(this.props.history)
    this.props.history.go(-1);
  }

  render() {
    return (
      <div className="text-center">
        <img src={emptyStage} style={{}} />
        <div className="mt40 empty-stage-title">Oops! Something went wrong.</div>
        <div className="mt25 empty-stage-msg">The page you are looking for seems to be missing.</div>
        <Button className="continueBtn mt30" onClick={this.goBack}>
          <span className="continueBtnTxt">Go Back</span>
        </Button>
      </div>
    );
  };
}

export default NoData;
